<template>
    <div v-if="loaded">
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-area
                :class="{ 'pb-0': !boxPacienteVisible }"
                id="box-paciente"
                title="Dados do paciente"
                type="fieldset"
            >
                <template slot="trailing">
                    <rkm-button
                        @click="boxPacienteVisible = !boxPacienteVisible"
                        color="primary"
                        small
                    >
                        <rkm-icon :icon="boxPacienteVisible ? 'angle-double-up' : 'angle-double-down'" />
                    </rkm-button>
                </template>

                <rkm-collapse :visible="boxPacienteVisible">
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                disabled
                                label="Nome"
                                v-model="form.paciente.nome"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                disabled
                                label="Prontuário"
                                v-model="form.paciente.prontuario"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                disabled
                                label="Data de nascimento"
                                v-model="form.paciente.dataNascimento"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-input
                                disabled
                                label="Idade"
                                v-model="form.paciente.idade"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                disabled
                                label="Raça/cor"
                                v-model="form.paciente.racaCor"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-input
                                disabled
                                label="Nome da mãe"
                                v-model="form.paciente.nomeMae"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate"
                                :validations="validations.cns"
                                label="CNS"
                                v-mask="mask.cns"
                                v-model="form.paciente.cns"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate"
                                :validations="validations.cpf"
                                label="CPF"
                                v-mask="mask.cpf"
                                v-model="form.paciente.cpf"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate"
                                :validations="validations.rg"
                                label="RG"
                                v-model="form.paciente.rg"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate"
                                :validations="validations.protocoloCross"
                                label="Prontuário estadual"
                                v-model="form.paciente.protocoloCross"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate"
                                :validations="validations.peso"
                                append="kg"
                                label="Peso"
                                placeholder="000.00"
                                v-mask="pesoMask"
                                v-model="model.peso"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate"
                                :validations="validations.altura"
                                append="cm"
                                label="Altura"
                                placeholder="000"
                                v-mask="'###'"
                                v-model="model.altura"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input
                                disabled
                                label="Endereço"
                                v-model="form.paciente.endereco"
                            />
                        </rkm-col>

                        <rkm-col
                            v-if="additionals.allowUpdate"
                            cols="auto"
                        >
                            <rkm-button
                                :label="false"
                                @click="$refs.ModalTentativaContato.open()"
                                color="primary"
                            >
                                Tentativa de contato
                            </rkm-button>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-form-radio-group
                                :disabled="!additionals.allowUpdate || fezAgendamentoAgora"
                                @change="handleObito"
                                class="mb-0"
                                label="Óbito"
                                v-model="model.obito"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-area
                        v-if="model.obito"
                        title="Óbito"
                        type="fieldset"
                    >
                        <rkm-row>
                            <rkm-col cols="2">
                                <rkm-form-date-picker
                                    :disabled="!additionals.allowUpdate"
                                    :max-date="additionals.dataAtual"
                                    :validations="validations.obito.obitoEm"
                                    label="Data do óbito"
                                    v-model="form.paciente.obito.obitoEm"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-input
                                    :disabled="!additionals.allowUpdate"
                                    :validations="validations.obito.declaracao"
                                    label="Declaração"
                                    number
                                    v-model="form.paciente.obito.declaracao"
                                />
                            </rkm-col>

                            <rkm-col cols="8">
                                <rkm-form-input
                                    :disabled="!additionals.allowUpdate"
                                    :validations="validations.obito.causa"
                                    label="Causa"
                                    v-model="form.paciente.obito.causa"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-input-autocomplete
                                    :disabled="!additionals.allowUpdate"
                                    :repository="repositories.cid"
                                    :search-fields="[
                                        { key: 'cid.codigo', searchable: true },
                                        { key: 'cid.nome', searchable: true },
                                    ]"
                                    :text-field="c => `${c.codigo} - ${c.nome}`"
                                    label="CID"
                                    v-model="form.paciente.obito.cid"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-input-autocomplete
                                    :disabled="!additionals.allowUpdate"
                                    :repository="repositories.usuario"
                                    :search-fields="[
                                        { key: 'cadastroCidadao.nome', searchable: true },
                                        { key: 'cadastroCidadao.cns', searchable: true },
                                    ]"
                                    :text-field="u => u.cidadaoCns ? `${this.formatCns(u.cidadaoCns)} - ${u.cidadaoNome}` : u.cidadaoNome"
                                    label="Profissional"
                                    v-model="form.paciente.obito.usuario"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-collapse>
            </rkm-area>

            <rkm-area
                :class="['mt-3', { 'pb-0': !boxInformacoesVisible }]"
                id="box-paciente"
                title="Informações da solicitação"
                type="fieldset"
            >
                <template slot="trailing">
                    <rkm-button
                        @click="boxInformacoesVisible = !boxInformacoesVisible"
                        color="primary"
                        small
                    >
                        <rkm-icon :icon="boxInformacoesVisible ? 'angle-double-up' : 'angle-double-down'" />
                    </rkm-button>
                </template>

                <rkm-collapse :visible="boxInformacoesVisible">
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input
                                disabled
                                label="Profissional solicitante"
                                v-model="form.solicitacao.usuarioSolicitanteNome"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-area
                                title="Procedimento(s) / Especialidade"
                                type="fieldset"
                                no-margin-top
                            >
                                <rkm-table
                                    :fields="fields.itens"
                                    :items="form.solicitacao.itens"
                                    hide-filters
                                    hide-pagination
                                />
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                disabled
                                label="Observação"
                                v-model="form.solicitacao.observacao"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-collapse>
            </rkm-area>

            <rkm-area
                class="mt-3"
                id="box-paciente"
                title="Movimentação da solicitação"
                type="fieldset"
            >
                <template v-if="additionals.allowUpdate">

                    <rkm-alert
                        color="info"
                        v-if="additionals.iniciouAtendimento"
                    >
                        Atendimento iniciado no módulo agendado.
                    </rkm-alert>

                    <rkm-row>
                        <rkm-col cols="2">
                            <rkm-form-select
                                :disabled="fezAgendamentoAgora"
                                :options="status"
                                :validations="validations.status"
                                label="Status"
                                show-default-option
                                text-field="nome"
                                v-model="model.statusId"
                                value-field="id"
                            />
                        </rkm-col>

                        <template v-if="isStatusDeAgendamento">
                            <rkm-col
                                v-if="isRegulacaoTipoAmbos"
                                cols="auto"
                            >
                                <rkm-form-radio-group
                                    :disabled="fezAgendamentoAgora"
                                    @change="clearFromTipoPrestador"
                                    label="Tipo de prestador"
                                    v-model="form.prestadorTipo"
                                >
                                    <rkm-form-radio :value="enums.regulacaoTipo.INTERNO">Interno</rkm-form-radio>
                                    <rkm-form-radio :value="enums.regulacaoTipo.EXTERNO">Externo</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <template v-if="isRegulacaoTipoInterno || (isRegulacaoTipoAmbos && isPrestadorTipoInterno)">
                                <rkm-col>
                                    <rkm-form-select
                                        :disabled="fezAgendamentoAgora"
                                        :options="form.prestadoresInternos"
                                        :validations="validations.prestadorInterno"
                                        label="Prestador interno"
                                        show-default-option
                                        text-field="nome"
                                        v-model="model.prestadorInternoId"
                                        value-field='id'
                                    />
                                </rkm-col>
                            </template>

                            <template v-if="isRegulacaoTipoExterno || (isRegulacaoTipoAmbos && isPrestadorTipoExterno)">
                                <rkm-col>
                                    <rkm-form-select
                                        :options="form.prestadoresExternos"
                                        :validations="validations.prestadorExterno"
                                        label="Prestador externo"
                                        show-default-option
                                        text-field="nome"
                                        v-model="model.prestadorExternoId"
                                        value-field='id'
                                    />
                                </rkm-col>
                            </template>

                            <rkm-col cols="2">
                                <rkm-form-date-picker
                                    :disabled="isPrestadorTipoInterno || fezAgendamentoAgora"
                                    :min-date="additionals.dataAtual"
                                    :validations="validations.dataAgendada"
                                    label="Data agendada"
                                    v-model="model.dataAgendada"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-time-picker
                                    :disabled="isPrestadorTipoInterno || fezAgendamentoAgora"
                                    :validations="validations.horaAgendada"
                                    label="Hora agendada"
                                    right
                                    v-model="model.horaAgendada"
                                />
                            </rkm-col>
                        </template>

                        <rkm-col
                            v-else-if="isStatusRealizado"
                            cols="2"
                        >
                            <rkm-form-date-picker
                                disabled
                                label="Data"
                                v-model="form.solicitacao.dataAgendada"
                            />
                        </rkm-col>


                    </rkm-row>

                    <rkm-row v-if="isStatusDeAgendamento && (isPrestadorTipoExterno || savedProtocoloAgendamento)">
                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="form.opcoesRetiradaProtocoloAgendamento"
                                label="Retirada do protocolo"
                                text-field="nome"
                                v-model="model.opcaoRetiradaProtocoloAgendamentoId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col v-if="model.opcaoRetiradaProtocoloAgendamentoId === enums.opcaoRetiradaProtocoloAgendamento.RETIRADO">
                            <rkm-form-input
                                :validations="validations.nomePessoaRetiradaProtocoloAgendamento"
                                label="Nome de quem retirou o protocolo"
                                uppercase
                                v-model="model.nomePessoaRetiradaProtocoloAgendamento"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="isStatusCancelado">
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.justificativaCancelamento"
                                label="Justificativa"
                                v-model="model.justificativaCancelamento"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="isStatusReagendado">
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.justificativaReagendamento"
                                label="Justificativa"
                                v-model="model.justificativaReagendamento"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="isStatusRemarcar">
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.justificativaRemarcacao"
                                label="Justificativa"
                                v-model="model.justificativaRemarcacao"
                            />
                        </rkm-col>
                    </rkm-row>
                </template>

                <rkm-area
                    no-margin-top
                    title="Movimentações"
                >
                    <template slot="trailing">
                        <rkm-button
                            v-if="additionals.allowUpdate"
                            @click="boxHistoricoMovimentacoesVisible = !boxHistoricoMovimentacoesVisible"
                            color="primary"
                            small
                        >
                            <rkm-icon :icon="boxHistoricoMovimentacoesVisible ? 'angle-double-up' : 'angle-double-down'" />
                        </rkm-button>

                        <rkm-button
                            @click="printHistoricoMovimentacoes"
                            color="info"
                            small
                        >
                            <rkm-icon icon="print" />
                        </rkm-button>
                    </template>

                    <rkm-collapse :visible="boxHistoricoMovimentacoesVisible">
                        <rkm-table
                            :items="form.historicoMovimentacoes"
                            :fields="fields.historicoMovimentacoes"
                            hide-filters
                            sort-by="dataHoraMovimentacao"
                            sort-desc
                        />
                    </rkm-collapse>
                </rkm-area>
            </rkm-area>
        </rkm-form>

        <ModalTentativaContato
            :solicitacao="solicitacao"
            ref="ModalTentativaContato"
            show-historico
        />

        <ModalAgendamentoExameLaboratorial
            :paciente-id="form.paciente.id"
            :regulacao-solicitacao="solicitacaoAgendamentoInternoData"
            @save="handleAgendado"
            hide-agendamentos
            ref="ModalAgendamentoExameLaboratorial"
        />

        <ModalAgendamentoExameImagem
            :paciente-id="form.paciente.id"
            :regulacao-solicitacao="solicitacaoAgendamentoInternoData"
            @save="handleAgendado"
            hide-agendamentos
            ref="ModalAgendamentoExameImagem"
        />

        <ModalAgendamentoAmbulatorio
            :paciente-id="form.paciente.id"
            :regulacao-solicitacao="solicitacaoAgendamentoInternoData"
            @save="handleAgendado"
            ref="ModalAgendamentoAmbulatorio"
        />

        <ModalProtocoloAgendamento
            :data="data"
            @save="handleSaveProtocoloAgendamento"
            ref="ModalProtocoloAgendamento"
        />
    </div>
</template>

<script>
// Components.
import ModalTentativaContato from '@/components/regulacao/fila/components/tentativa-contato/components/cadastro/Modal'
import ModalAgendamentoExameLaboratorial from '@/components/exame-laboratorial/agendamento-exame/Modal'
import ModalAgendamentoExameImagem from '@/components/exame-imagem/agendamento/Modal'
import ModalAgendamentoAmbulatorio from '@/components/ambulatorio/agendamento/components/cadastro/Modal'
import ModalProtocoloAgendamento from './components/protocolo-agendamento/Modal'

// Mixins.
import { repository, error, object, stringCase, mask, unmask, data, formats, file } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Enums.
import statusTipo from '@/enums/regulacao/statusTipo'
import regulacaoTipo from '@/enums/regulacao/tipo'
import opcaoRetiradaProtocoloAgendamento from '@/enums/regulacao/opcaoRetiradaProtocoloAgendamento'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

// Others.
import moment from 'moment'

export default {
    components: {
        ModalTentativaContato,
        ModalAgendamentoExameLaboratorial,
        ModalAgendamentoExameImagem,
        ModalAgendamentoAmbulatorio,
        ModalProtocoloAgendamento,
    },
    computed: {
        validations() {

            return {
                cns: { required: true, min_max_without_mask: 15, cns: true },
                cpf: { required: true, min_max_without_mask: 11, cpf: true },
                rg: { min: 6, max: 15 },
                protocoloCross: { required: true, max: 10 },
                peso: { min_value: 0.5, max_value: 500 },
                altura: { min_value: 20, max_value: 250 },
                obito: {
                    obitoEm: { required: true },
                    declaracao: { min: 1, max: 13 },
                    causa: { min: 1, max: 255 },
                },
                status: { required: true },
                nomePessoaRetiradaProtocoloAgendamento: { required: true, max: 150 },
                justificativaCancelamento: { required: true, max: 500 },
                justificativaReagendamento: { required: true, max: 500 },
                justificativaRemarcacao: { required: true, max: 500 },
                prestadorInterno: { required: true },
                prestadorExterno: { required: true },
                dataAgendada: { required: true },
                horaAgendada: { required: true },
            }
        },
        pesoMask() {

            const length = (this.model.peso ?? '').replace('.', '').length

            if (length <= 3) {

                return '#.##'
            }
            else if (length <= 4) {

                return '##.##'
            }
            else {

                return '###.##'
            }
        },
        status() {

            if (this.model.obito) {

                return this.form.status.filter(s => s.tipoId === this.enums.statusTipo.CANCELADO)
            }

            return this.form.status
        },
        isStatusDeAgendamento() {

            return [
                this.enums.statusTipo.AGENDADO,
                this.enums.statusTipo.REAGENDADO,
            ].includes(this.statusTipoId)
        },
        isStatusRealizado() {

            return this.statusTipoId === this.enums.statusTipo.REALIZADO
        },
        isStatusCancelado() {

            return this.statusTipoId === this.enums.statusTipo.CANCELADO
        },
        isStatusAgendado() {

            return this.statusTipoId === this.enums.statusTipo.AGENDADO
        },
        isStatusReagendado() {

            return this.statusTipoId === this.enums.statusTipo.REAGENDADO
        },
        isStatusRemarcar() {

            return this.statusTipoId === this.enums.statusTipo.REMARCAR
        },
        statusTipoId() {

            if (this.model.statusId) {

                return this.form.status.find(s => s.id === this.model.statusId).tipoId
            }

            return null
        },
        isRegulacaoTipoInterno() {

            return this.form.solicitacao.regulacaoTipoId === this.enums.regulacaoTipo.INTERNO
        },
        isRegulacaoTipoExterno() {

            return this.form.solicitacao.regulacaoTipoId === this.enums.regulacaoTipo.EXTERNO
        },
        isRegulacaoTipoAmbos() {

            return this.form.solicitacao.regulacaoTipoId === this.enums.regulacaoTipo.AMBOS
        },
        isPrestadorTipoInterno() {

            return this.form.prestadorTipo === this.enums.regulacaoTipo.INTERNO
        },
        isPrestadorTipoExterno() {

            return this.form.prestadorTipo === this.enums.regulacaoTipo.EXTERNO
        },
        data() {

            if (!this.loaded) {

                return null
            }

            return {
                additionals: this.additionals,
                form: this.form,
                model: this.model,
                fezAgendamentoAgora: this.fezAgendamentoAgora,
                isStatusAgendado: this.isStatusAgendado,
                isStatusReagendado: this.isStatusReagendado,
                isPrestadorTipoInterno: this.isPrestadorTipoInterno,
            }
        },
        solicitacaoAgendamentoInternoData() {

            return {
                ...this.clone(this.form.solicitacao),
                prestador: this.clone(this.form.prestadoresInternos
                    .find(p => p.id === this.model.prestadorInternoId) ?? null)
            }
        }
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila'),
            impressao: this.getConectaSusRepository('impressao.regulacao'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            boxPacienteVisible: true,
            boxInformacoesVisible: true,
            boxHistoricoMovimentacoesVisible: false,
            fields: {
                itens: [
                    { key: 'codigo', label: 'Código', sortable: true, class: 'col-min' },
                    { key: 'nome', label: 'Nome', sortable: true },
                ],
                historicoMovimentacoes: [
                    { key: 'statusNome', label: 'Status', sortable: true },
                    { key: 'prestadorDescricao', label: 'Prestador', sortable: true },
                    {
                        key: 'dataAgendada',
                        label: 'Data agendada',
                        sortable: true,
                        formatter: v => v ? this.formatDate(v) : null,
                        filterByFormatted: true,
                    },
                    { key: 'horaAgendada', label: 'Hora agendada', sortable: true },
                    { key: 'opcaoRetiradaProtocoloAgendamentoNome', label: 'Status do protocolo', sortable: true },
                    { key: 'nomePessoaRetiradaProtocoloAgendamento', label: 'Protocolo retirado por', sortable: true },
                    {
                        key: 'dataHoraMovimentacao',
                        label: 'Data/hora da movimentação',
                        sortable: true,
                        formatter: v => this.formatDateTime(v),
                        filterByFormatted: true,
                    },
                    { key: 'usuarioQueMovimentou', label: 'Usuário que atualizou', sortable: true },
                ],
            },
            enums: { statusTipo, regulacaoTipo, opcaoRetiradaProtocoloAgendamento, subclassificacao },
            others: { moment },
            initials: { form: null, model: null },
            fezAgendamentoAgora: false,
            savedProtocoloAgendamento: false,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.fila.editSolicitacao(this.solicitacao.id)
                .then(({ data }) => {

                    if (data.form.paciente.obito.obitoEm) {

                        data.form.paciente.obito.obitoEm = this.others
                            .moment(data.form.paciente.obito.obitoEm, 'DD/MM/YYYY')
                            .toDate()
                    }

                    if (data.form.solicitacao.dataAgendada) {

                        data.form.solicitacao.dataAgendada = this.others
                            .moment(data.form.solicitacao.dataAgendada, 'DD/MM/YYYY')
                            .toDate()
                    }

                    this.boxHistoricoMovimentacoesVisible = !data.additionals.allowUpdate

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.initials.form = this.clone(this.form)
                    this.initials.model = this.clone(this.model)

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleObito() {

            if (this.model.obito) {

                const statusCancelado = this.form.status.find(s => s.tipoId === this.enums.statusTipo.CANCELADO)

                this.model.statusId = statusCancelado ? statusCancelado.id : null
            }
        },
        handleAgendado(agendamento) {

            this.fezAgendamentoAgora = true

            if (this.additionals.moduloAgendamento === 'exame-laboratorial') {

                this.model.dataAgendada = this.others.moment(agendamento.data, 'DD/MM/YYYY').toDate()
                this.model.horaAgendada = agendamento.horaExame
            }
            else if (this.additionals.moduloAgendamento === 'exame-imagem') {

                this.model.dataAgendada = this.others.moment(agendamento.agendamentoAtual.data).toDate()
                this.model.horaAgendada = agendamento.agendamentoAtual.horaExame
            }
            else if (this.additionals.moduloAgendamento === 'ambulatorio') {

                this.model.dataAgendada = this.others.moment(agendamento.data, 'DD/MM/YYYY').toDate()
                this.model.horaAgendada = agendamento.horario
            }

            this.$refs.ModalProtocoloAgendamento.open()
        },
        handleSaveProtocoloAgendamento() {

            this.savedProtocoloAgendamento = true

            this.save()
        },
        handleSave() {

            this.$refs.Form.validate().then(async valid => {

                if (!valid) {

                    if (document.querySelectorAll("#box-paciente .is-invalid").length > 0) {

                        this.boxPacienteVisible = true

                        setTimeout(() => this.$refs.Form.validate(), 300)
                    }

                    return
                }

                this.setLoading()

                try {

                    await this.repositories.fila.updatePaciente(this.form.paciente.id, this.preparePacienteData())

                    if (this.isStatusDeAgendamento && this.isPrestadorTipoInterno && !this.fezAgendamentoAgora) {

                        this.openModalAgendamento()
                    }
                    else if (this.isStatusRemarcar) {

                        this.showConfirmation(
                            'A posição será alterada para a última de acordo com a prioridade. Deseja continuar?',
                            async () => this.save(),
                            async () => {},
                            this.handleError
                        )
                    }
                    else {

                        this.save()
                    }
                }
                catch (error) {

                    this.handleError(error)
                }
                finally {

                    this.unsetLoading()
                }
            })
        },
        openModalAgendamento() {

            if (this.additionals.moduloAgendamento === 'exame-laboratorial') {

                this.$refs.ModalAgendamentoExameLaboratorial.open();
            }
            else if (this.additionals.moduloAgendamento === 'exame-imagem') {

                this.$refs.ModalAgendamentoExameImagem.open()
            }
            else if (this.additionals.moduloAgendamento === 'ambulatorio') {

                this.openModalAgendamentoAmbulatorio()
            }
        },
        openModalAgendamentoAmbulatorio() {

            const openModal = async () => {

                if (this.additionals.ambulatorio.avisaCnsProvisorio) {

                    this.showWarningNotification('Paciente com CNS provisório.')
                }

                if (this.form.solicitacao.ambulatorioAgendamentoId) {

                    this.$refs.ModalAgendamentoAmbulatorio.edit(this.form.solicitacao.ambulatorioAgendamentoId)
                }
                else {

                    this.$refs.ModalAgendamentoAmbulatorio.create()
                }
            }

            if (this.additionals.ambulatorio.cadastroPacienteVencido) {

                this.showWarningNotification(`Paciente com cadastro temporário desatualizado. Agendamento não permitido.`)
            }
            else if (this.form.paciente.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                && this.additionals.avisaCnsTemporarioInvalido
            ) {

                this.showConfirmation(`Paciente com cadastro temporário. Deseja continuar?`, openModal)
            }
            else {

                openModal()
            }
        },
        save() {

            this.setLoading()

            this.repositories.fila.updateSolicitacao(this.solicitacao.id, this.prepareData())
                .then(() => {

                    this.showSaveNotification()
                    this.$emit('save')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data, [
                'dataAgendada'
            ], 'DD/MM/YYYY')

            if (data.horaAgendada) {

                data.horaAgendada = data.horaAgendada.substring(0, 5)
            }

            data.paciente = {
                obito: {
                    obitoEm: this.model.obito
                        ? this.others.moment(this.form.paciente.obito.obitoEm).format('DD/MM/YYYY')
                        : null,
                    declaracao: this.model.obito ? this.form.paciente.obito.declaracao : null,
                    causa: this.model.obito ? this.form.paciente.obito.causa : null,
                    cidId: this.model.obito && this.form.paciente.obito.cid ? this.form.paciente.obito.cid.id : null,
                    usuarioId: this.model.obito && this.form.paciente.obito.usuario
                        ? this.form.paciente.obito.usuario.id
                        : null,
                },
            }

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        preparePacienteData() {

            return this.camelObjectKeysToSnakeRecursive({
                cns: this.unMaskCns(this.form.paciente.cns),
                cpf: this.unMaskCpf(this.form.paciente.cpf),
                rg: this.form.paciente.rg,
                protocoloCross: this.form.paciente.protocoloCross,
            })
        },
        clearFromTipoPrestador() {

            this.model.prestadorInternoId = null
            this.model.prestadorExternoId = null

            this.model.dataAgendada = null
            this.model.horaAgendada = null
        },
        printHistoricoMovimentacoes() {

            this.setLoading()

            this.repositories.impressao.historicoMovimentacaoSolicitacao(this.solicitacao.id)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error, object, stringCase, mask, unmask, data, formats, file],
    props: {
        solicitacao: { type: Object, required: true },
    },
    watch: {
        data: {
            deep: true,
            handler(data) {

                this.$emit('data-change', data)
            }
        },
    }
}
</script>